export default {
  init() {
    // JavaScript to be fired
  },
  finalize() {
    // JavaScript to be fired, after page specific JS is fired
    const bookWrap = $('.book-wrap');
    const enquireWidget = bookWrap.find('.enquire-widget');

    if (enquireWidget.length) {
      const menuSelectVenue = enquireWidget.find('.menu-select-venue');
      if (menuSelectVenue.length) {
        const selectedVenue = menuSelectVenue.val();
        const venueInput = enquireWidget.find('.hotel-enquire-form input[name="venue"]');

        venueInput.val(selectedVenue);

        menuSelectVenue.on('select2:select', function () {
          const _this = $(this);
          const selectedVal = _this.val();

          venueInput.val(selectedVal);
        });
      }

      const enquireFormWrapper = enquireWidget.find('.enquire-form-wrapper');
      if (enquireFormWrapper.length) {
        enquireFormWrapper.each(function() {
          const _this = $(this);

          const stepOneForm = _this.find('form.wpcf7-form .tab-content .tab-pane:nth-child(1)');
          const stepTwoForm = _this.find('form.wpcf7-form .tab-content .tab-pane:nth-child(2)');
          const pageNumber = _this.find('.page-number strong');
          const nextBtn = _this.find('.next-btn');
          const backSubmitBtns = _this.find('.back-submit-btns');
          const backBtn = _this.find('.back-btn');
          const submitBtn = _this.find('.submit-btn');

          $(document).on('wpcf7submit', function() {
            nextBtn.removeClass('disabled');
            backBtn.removeClass('disabled');
            submitBtn.removeClass('disabled');
          });

          $(document).on('wpcf7invalid', function() {
            nextBtn.removeClass('disabled');
            backBtn.removeClass('disabled');
            submitBtn.removeClass('disabled');

            let requiredSelectField = $('select.wpcf7-validates-as-required');
            if (requiredSelectField.length) {
              requiredSelectField.each(function() {
                let _this = $(this);

                if (_this.val() === '') {
                  _this.addClass('wpcf7-not-valid');
                } else {
                  _this.removeClass('wpcf7-not-valid');
                }
              });
            }
          });

          nextBtn.keypress(function(e) {
            if (e.key === 'Enter') {
              nextBtn.trigger('click');
            }
          });

          nextBtn.click(function(e) {
            e.preventDefault();

            // Step one form
            const formOneRequiredInputs = stepOneForm.find('.wpcf7-validates-as-required');
            formOneRequiredInputs.each(function() {
              const _this = $(this);

              if (_this.val() === '') {
                _this.addClass('wpcf7-not-valid');
              } else {
                _this.removeClass('wpcf7-not-valid');
              }
            });

            let formOneInvalidFields = stepOneForm.find('.wpcf7-not-valid');
            if (formOneInvalidFields.length === 0) {
              _this.find('.nav .tab.active[data-toggle="tab"]').next('a').trigger('click');
              pageNumber.text('02');
              nextBtn.addClass('hidden');
              backSubmitBtns.removeClass('hidden');
              backBtn.removeClass('hidden');
              submitBtn.removeClass('hidden');
            }
          });

          backBtn.click(function(e) {
            e.preventDefault();

            _this.find('.nav .tab.active[data-toggle="tab"]').prev('a').trigger('click');
            pageNumber.text('01');
            nextBtn.removeClass('hidden');
            backSubmitBtns.addClass('hidden');
            backBtn.addClass('hidden');
            submitBtn.addClass('hidden');
          });

          submitBtn.keypress(function(e) {
            if (e.key === 'Enter') {
              submitBtn.trigger('click');
            }
          });

          submitBtn.click(function(e) {
            e.preventDefault();

            // Disable form buttons
            nextBtn.addClass('disabled');
            backBtn.addClass('disabled');
            submitBtn.addClass('disabled');

            // Step two form validations
            _this.find('input.wpcf7-submit[type="submit"]').trigger('click');

            $(document).on('wpcf7invalid', function() {
              // check if there's some error on step one form
              let formOneInvalidFields = stepOneForm.find('.wpcf7-not-valid');
              if (formOneInvalidFields.length) {
                _this.find('.nav .tab.active[data-toggle="tab"]').prev('a').trigger('click');
                pageNumber.text('01');
                nextBtn.removeClass('hidden');
                backSubmitBtns.addClass('hidden');
                backBtn.addClass('hidden');
                submitBtn.addClass('hidden');
              }

              // check if there's some error on step two form
              let formTwoRequiredFields = stepTwoForm.find('.wpcf7-validates-as-required');
              if (formTwoRequiredFields.length) {
                formTwoRequiredFields.each(function() {
                  let _this = $(this);

                  if (_this.val() === '') {
                    _this.addClass('wpcf7-not-valid');
                  } else {
                    _this.removeClass('wpcf7-not-valid');
                  }
                });
              }
            });
          });
        });
      }
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/modules/bookVenue.js